import { GridApiCommunity } from "@mui/x-data-grid/internals";
import { MutableRefObject, useMemo } from "react";
import { CustomDataGridWithMultipleFiltersProps } from "../../Interfaces/CustomDataGrid.interfaces";

const defaultGetRowId = (row: any) => row.id ?? crypto.randomUUID();

export const useDataGridConfig = (
  props: CustomDataGridWithMultipleFiltersProps,
  apiRef: MutableRefObject<GridApiCommunity>,
  paginationModel: any,
  gridRows: any[],
  onFilterChange: any,
  handlePaginationChange: any,
  onSortModelChange: any
) => {
  const enableUrlParams = !!props.enableUrlParams;

  return useMemo(
    () => ({
      apiRef,
      columnHeaderHeight: props.columnHeaderHeight,
      columns: props.columns,
      density: props.density ?? "compact",
      disableRowSelectionOnClick: props.disableRowSelectionOnClick ?? true,
      enableUrlParams,
      filterDebounceMs: props.filterDebounceMs ?? 500,
      filterMode: props.filterMode,
      getRowClassName: props.getRowClassName,
      getRowId: props.getRowId ?? defaultGetRowId,
      initialState: props.initialState,
      keepNonExistentRowsSelected: props.keepNonExistentRowsSelected ?? true,
      loading: props.loading,
      onFilterModelChange: onFilterChange,
      onPaginationModelChange: handlePaginationChange,
      onSortModelChange,
      onColumnVisibilityModelChange: props.onColumnVisibilityModelChange,
      pageSizeOptions: props.pageSizeOptions ?? [10, 25, 50, 75, 100],
      paginationMode: props.paginationMode,
      paginationModel,
      rowCount: props.paginationMode === "server" ? props.rows.count : undefined,
      rowHeight: props.rowHeight,
      rows: gridRows,
      sortingMode: props.sortingMode,
      sortingOrder: props.sortingOrder,
      disableColumnSorting: props.disableColumnSorting,
      hideFooter: props.hideFooter ?? false,
      sx: {
        ...props.styles,
        ...props.sx,
        "& .MuiDataGrid-menuIconButton": { color: "white" }
      }
    }),
    [
      apiRef,
      props.columnHeaderHeight,
      props.columns,
      props.density,
      props.disableRowSelectionOnClick,
      enableUrlParams,
      props.filterDebounceMs,
      props.filterMode,
      props.getRowClassName,
      props.getRowId,
      props.initialState,
      props.keepNonExistentRowsSelected,
      props.loading,
      onFilterChange,
      handlePaginationChange,
      onSortModelChange,
      props.onColumnVisibilityModelChange,
      props.pageSizeOptions,
      props.paginationMode,
      paginationModel,
      props.rows.count,
      props.rowHeight,
      gridRows,
      props.sortingMode,
      props.sortingOrder,
      props.disableColumnSorting,
      props.hideFooter,
      props.styles,
      props.sx
    ]
  );
};
